import { render, staticRenderFns } from "./investigacion-editar.vue?vue&type=template&id=4ba04e6e&scoped=true&"
import script from "./investigacion-editar.vue?vue&type=script&lang=js&"
export * from "./investigacion-editar.vue?vue&type=script&lang=js&"
import style0 from "./investigacion-editar.vue?vue&type=style&index=0&id=4ba04e6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba04e6e",
  null
  
)

export default component.exports